<template>
  <v-card class="ma-2">
    <v-card-title>{{formType == "sat" ? "Tipo de solicitud de asistencia técnica" : "Tipo de resolución de incidencia" }}</v-card-title>
    <v-card-text>
      <v-radio-group v-model="request.type" row>
          <v-radio :value="item.value" :label="item.label" v-for="item in request.values" v-bind:key="item.value"></v-radio>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RequestType",
  props: ["formType", "request"]
}
</script>

<style scoped>

</style>